const Cart = ({ color = "var(primary100)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1837 4.27759C20.6639 4.93343 21.5945 6.29977 21.8188 8.12519C21.9085 8.81382 21.8861 9.54618 21.7852 10.2785C21.4712 12.4756 20.3835 14.6727 18.9371 15.7767C17.8382 16.6074 16.4365 17.0118 15.0125 17.1977C14.1491 17.3179 13.2745 17.3507 12.4559 17.3507C12.1644 17.3507 11.8728 17.3507 11.5925 17.3397C9.52933 17.2851 6.90548 17.0556 5.01048 15.7439C2.46554 13.9843 2.75656 10.247 3.01443 6.93539L3.01456 6.93375C3.01787 6.89216 3.02118 6.85065 3.02449 6.80921C3.11072 5.72891 3.19272 4.70155 3.16033 3.78571C3.20518 2.41938 1.74748 2.14611 1.57929 2.12425C1.13077 2.04773 0.816803 1.63237 0.884082 1.18421C0.962573 0.746982 1.38867 0.451854 1.83719 0.506507C2.89121 0.659537 4.85349 1.53399 4.84228 3.72013C4.84228 3.77508 4.84326 3.82999 4.84464 3.88487C4.85002 4.09889 5.03667 4.26969 5.25607 4.26022C7.41634 4.164 9.56635 4.06824 11.7271 3.99339C12.9381 3.94967 14.1379 3.91688 15.3489 3.89502C15.4498 3.89502 15.5479 3.89228 15.646 3.88955C15.7441 3.88682 15.8423 3.88409 15.9432 3.88409L15.9843 3.88276C16.9942 3.85021 18.1217 3.81388 19.1837 4.27759ZM12.3662 9.78665H15.4722C15.9432 9.78665 16.3132 9.41501 16.3132 8.96685C16.3132 8.51869 15.9432 8.14705 15.4722 8.14705H12.3662C11.9065 8.14705 11.5252 8.51869 11.5252 8.96685C11.5252 9.41501 11.9065 9.78665 12.3662 9.78665Z"
        fill={color}
      />
      <path
        d="M5.93409 18.67C5.13348 18.67 4.482 19.304 4.482 20.0845C4.482 20.8649 5.13348 21.5 5.93409 21.5C6.7347 21.5 7.38506 20.8649 7.38506 20.0845C7.38506 19.304 6.7347 18.67 5.93409 18.67Z"
        fill={color}
      />
      <path
        d="M17.5183 18.67C16.7177 18.67 16.0673 19.304 16.0673 20.0845C16.0673 20.8649 16.7177 21.5 17.5183 21.5C18.3189 21.5 18.9704 20.8649 18.9704 20.0845C18.9704 19.304 18.3189 18.67 17.5183 18.67Z"
        fill={color}
      />
    </svg>
  );
};

export default Cart;
